// extracted by mini-css-extract-plugin
module.exports = {"card":"ResourceCard_card__04oLA","icon":"ResourceCard_icon__3xrJd","title":"ResourceCard_title__f1a2Q"};